import React from 'react';
import { SvgIcon } from 'ui/SvgIcon';
import { HidingTooltip } from 'ui/Tooltip';
import CheckIcon from 'ui/Icons/tabler/check.component.svg';
import ExclamationCircleIcon from 'ui/Icons/tabler/exclamation-circle.component.svg';
import ExclamationTriangleIcon from 'ui/Icons/tabler/exclamation-triangle.component.svg';
import CircleXIcon from 'ui/Icons/tabler/circle-x.component.svg';
import CircleIcon from 'ui/Icons/tabler/circle.component.svg';

export const reviewStatusConfig: Record<string, { icon: React.FC<React.SVGProps<SVGSVGElement>>; iconClass: string; label: string }> = {
  approved: { icon: CheckIcon, iconClass: 'w-[18px] h-[18px] fill-transparent stroke-teal-100 stroke-2', label: 'Approved' },
  rejected: { icon: ExclamationTriangleIcon, iconClass: 'w-[18px] h-[18px] fill-red-95', label: 'Rejected' },
  pending: { icon: ExclamationCircleIcon, iconClass: 'w-[18px] h-[18px] fill-yellow-30', label: 'Reviewing' },
  'pending cancellation': { icon: ExclamationTriangleIcon, iconClass: 'w-[18px] h-[18px] fill-yellow-30', label: 'Pending Cancellation' },
  cancelled: { icon: CircleXIcon, iconClass: 'w-[18px] h-[18px] fill-gray-60', label: 'Cancelled' },
  initial: { icon: CircleIcon, iconClass: 'w-[18px] h-[18px] fill-gray-40', label: 'Initial' },
};

export const ReviewStatusBadge: React.FC<{ status: string | null }> = ({ status }) => {
  if (!status) return null;
  const config = reviewStatusConfig[status];
  if (!config) return null;

  return (
    <HidingTooltip
      renderTooltipContent={() => <div className="p-1 font-pt-sans text-[13px]">{config.label}</div>}
      position="bottom"
    >
      <SvgIcon IconComponent={config.icon} className={config.iconClass} />
    </HidingTooltip>
  );
};
